import {gsap} from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

function init() {
	gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

	function animPath1() {
		var animationChip;

		gsap.set("#motionSVG-1", { scale: 1, autoAlpha: 1 });
		gsap.set("#chip-1", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVG-1", {
			scrollTrigger: {
				trigger: "#motionPath-1",
				start: "0% 10%",
				end: "+=900",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPath-1",
				align: "#motionPath-1",
				alignOrigin: [0.5, 0.5],
				// autoRotate: 90,
			},
			onComplete() {
				$('#chip-2').removeClass('hide');
				$('#motionSVG-1').addClass('hide');
			}
		});
	}
	function animPath2() {
		var animationChip;

		gsap.set("#motionSVG-2", { scale: 1, autoAlpha: 1 });
		gsap.set("#chip-2", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVG-2", {
			scrollTrigger: {
				trigger: "#motionPath-2",
				start: "-22% 10%",
				end: "+=900",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPath-2",
				align: "#motionPath-2",
				alignOrigin: [0.5, 0.5],
				// autoRotate: 90,
			},
			onComplete() {
				$('#chip-3').removeClass('hide');
				$('#motionSVG-2').addClass('hide');
			}
		});
	}
	function animPath3() {
		var animationChip;

		gsap.set("#motionSVG-3", { scale: 1, autoAlpha: 1 });
		gsap.set("#chip-3", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVG-3", {
			scrollTrigger: {
				trigger: "#motionPath-3",
				start: "0% 10%",
				end: "+=1300",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPath-3",
				align: "#motionPath-3",
				alignOrigin: [0.5, 0.5],
				// autoRotate: 90,
			},
			onComplete() {
				$('#chip-4').removeClass('hide');
				$('#motionSVG-3').addClass('hide');
			}
		});
	}
	function animPath4() {
		var animationChip;

		gsap.set("#motionSVG-4", { scale: 1, autoAlpha: 1 });
		gsap.set("#chip-4", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVG-4", {
			scrollTrigger: {
				trigger: "#motionPath-4",
				start: "-6% 10%",
				end: "+=900",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPath-4",
				align: "#motionPath-4",
				alignOrigin: [0.5, 0.5],
				// autoRotate: 90,
			},
			onComplete() {
				// $('#chip-4').removeClass('hide');
				// $('#motionSVG-3').addClass('hide');
			}
		});
	}
	function animPath5() {
		var animationChip;

		gsap.set("#motionSVG-5", { scale: 1, autoAlpha: 1 });
		gsap.set("#chip-5", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVG-5", {
			scrollTrigger: {
				trigger: "#motionPath-5",
				start: "-20% 10%",
				end: "+=600",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPath-5",
				align: "#motionPath-5",
				alignOrigin: [0.5, 0.5],
				// autoRotate: 90,
			},
			onComplete() {
				// $('#chip-4').removeClass('hide');
				// $('#motionSVG-3').addClass('hide');
			}
		});
	}

	function animPathMobile1() {
		var animationChip;

		gsap.set("#motionSVGMobile-1", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-1", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-1", {
			scrollTrigger: {
				trigger: "#motionPathMobile-1",
				start: "-20% 10%",
				end: "+=1100",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-1",
				align: "#motionPathMobile-1",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile2() {
		var animationChip;

		gsap.set("#motionSVGMobile-2", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-2", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-2", {
			scrollTrigger: {
				trigger: "#motionPathMobile-2",
				start: "-180% 10%",
				end: "+=500",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-2",
				align: "#motionPathMobile-2",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile3() {
		var animationChip;

		gsap.set("#motionSVGMobile-3", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-3", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-3", {
			scrollTrigger: {
				trigger: "#motionPathMobile-3",
				start: "-300% 10%",
				end: "+=300",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-3",
				align: "#motionPathMobile-3",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile4() {
		var animationChip;

		gsap.set("#motionSVGMobile-4", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-4", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-4", {
			scrollTrigger: {
				trigger: "#motionPathMobile-4",
				start: "-40% 10%",
				end: "+=500",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-4",
				align: "#motionPathMobile-4",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile5() {
		var animationChip;

		gsap.set("#motionSVGMobile-5", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-5", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-5", {
			scrollTrigger: {
				trigger: "#motionPathMobile-5",
				start: "-150% 10%",
				end: "+=600",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-5",
				align: "#motionPathMobile-5",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile6() {
		var animationChip;

		gsap.set("#motionSVGMobile-6", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-6", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-6", {
			scrollTrigger: {
				trigger: "#motionPathMobile-6",
				start: "-80% 10%",
				end: "+=900",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-6",
				align: "#motionPathMobile-6",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile7() {
		var animationChip;

		gsap.set("#motionSVGMobile-7", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-7", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-7", {
			scrollTrigger: {
				trigger: "#motionPathMobile-7",
				start: "-120% 10%",
				end: "+=800",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-7",
				align: "#motionPathMobile-7",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile8() {
		var animationChip;

		gsap.set("#motionSVGMobile-8", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-8", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-8", {
			scrollTrigger: {
				trigger: "#motionPathMobile-8",
				start: "-120% 10%",
				end: "+=700",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-8",
				align: "#motionPathMobile-8",
				alignOrigin: [0.5, 0.5],
			},
		});
	}
	function animPathMobile9() {
		var animationChip;

		gsap.set("#motionSVGMobile-9", { scale: 1, autoAlpha: 1 });
		gsap.set("#chipAnimMobile-9", {transformOrigin: "50% 50%"});

		animationChip = gsap.to("#motionSVGMobile-9", {
			scrollTrigger: {
				trigger: "#motionPathMobile-9",
				start: "-80% 10%",
				end: "+=800",
				scrub: 0,
			},
			duration: 10,
			ease: "none",
			immediateRender: true,
			motionPath: {
				path: "#motionPathMobile-9",
				align: "#motionPathMobile-9",
				alignOrigin: [0.5, 0.5],
			},
		});
	}


	if($(window).width() >= 1024 ) {
		setTimeout(function (){
			animPath1();
			animPath2();
			animPath3();
			animPath4();
			animPath5();

			$(window).scroll(function(){
				if( $('.page').hasClass('longread') ) {
					let topSticky = 116;
					var height1 = $(".fixedAnim-1").offset().top - $(window).scrollTop();

					if( height1 > topSticky ) { // Если больше 116, то возвращение на анимацию motionSVG-1
						$('#chip-2').addClass('hide');
						$('#motionSVG-1').removeClass('hide');
					}  else if ( height1 === topSticky ) { // Если равен 116, то анимация scroll-1
						$('#chip-2').removeClass('hide');
						$('#motionSVG-1').addClass('hide');

						$('#motionSVG-2').addClass('hide');
					} else if( height1 < topSticky ) { // Иначе если меньше 116, то анимация motionSVG-2
						$('#chip-2').addClass('hide');
						$('#motionSVG-2').removeClass('hide');
					}

					let height2 = $(".fixedAnim-2").offset().top - $(window).scrollTop();

					if( height2 > topSticky ) { // Если больше 116, то возвращение на анимацию motionSVG-2
						$('#chip-3').addClass('hide');

					}  else if ( height2 === topSticky ) { // Если равен 116, то анимация scroll-2
						$('#chip-3').removeClass('hide');
						$('#motionSVG-2').addClass('hide');

						$('#motionSVG-3').addClass('hide');
					} else if( height2 < topSticky ) { // Иначе если меньше 116, то анимация motionSVG-3
						$('#chip-3').addClass('hide');
						$('#motionSVG-3').removeClass('hide');
					}

					let height3 = $(".fixedAnim-3").offset().top - $(window).scrollTop();

					if( height3 > topSticky ) { // Если больше 116, то возвращение на анимацию motionSVG-3
						$('#chip-4').addClass('hide');

					}  else if ( height3 === topSticky ) { // Если равен 116, то анимация scroll-3
						$('#chip-4').removeClass('hide');
						$('#motionSVG-3').addClass('hide');

						$('#motionSVG-4').addClass('hide');
					} else if( height3 < topSticky ) { // Иначе если меньше 116, то анимация motionSVG-4
						$('#chip-4').addClass('hide');
						$('#motionSVG-4').removeClass('hide');
					}


					let height4 = $(".fixedAnim-4").offset().top - $(window).scrollTop();

					if( height4 > topSticky ) { // Если больше 116, то возвращение на анимацию motionSVG-4
						$('#chip-5').addClass('hide');

					}  else if ( height4 === topSticky ) { // Если равен 116, то анимация scroll-4
						$('#chip-5').removeClass('hide');
						$('#motionSVG-4').addClass('hide');

						$('#motionSVG-5').addClass('hide');
					} else if( height4 < topSticky ) { // Иначе если меньше 116, то анимация motionSVG-5
						$('#chip-5').addClass('hide');
						$('#motionSVG-5').removeClass('hide');
					}
				}
			});
		}, 1000)
	} else {
		setTimeout(function (){
			animPathMobile1();
			animPathMobile2();
			animPathMobile3();
			animPathMobile4();
			animPathMobile5();
			animPathMobile6();
			animPathMobile7();
			animPathMobile8();
			animPathMobile9();
		}, 1000)
	}
}

function destroy() {

}

export default {
	init,

};
